import { useEffect, useState } from 'react';
import { Card, Box, Link, Grid } from '@mui/material';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { CardActionArea } from '@mui/material';
import PropTypes from 'prop-types';
import Text from './Text';
import TextEllipsize from 'utils/TextEllipsize';
import Loader from './Loader';
import { style } from 'constant/constants';

const getColor = (rec1, rec2) => {
  if (rec1) return style.recommended1;
  if (rec2) return style.recommended2;
  return 'white';
};

const FenceImageBox = ({ imgData, handleChange, handleMaterials }) => {
  const [loader, setLoader] = useState(false);
  const [highlightColor, setHighlightColor] = useState('white');

  useEffect(() => {
    if (imgData?.materials) {
      setLoader(true);
      setTimeout(() => {
        setLoader(false);
      }, [2000]);
    }
  }, []);
  useEffect(() => {
    setHighlightColor(getColor(imgData['1stRecommended'], imgData['2ndRecommended']));
  }, [imgData['1stRecommended'], imgData['2ndRecommended']]);

  const text = (
    <Text
      sx={{ m: 0, color: '#0000FF', fontSize: 14, fontWeight: 'bold' }}
      gutterBottom
      lineHeight={0.8}
      variant="body1">
      <TextEllipsize value={imgData.name} length={30} />
    </Text>
  );

  const materials =
    imgData?.materials?.length > 0
      ? imgData.materials.map((material) => {
          const materials = imgData.materials.map((element) => {
            return { name: element.material, id: element.materialId };
          });
          const value = material.materialId;
          return (
            <Text
              key={material.id}
              sx={{
                m: 0,
                mt: 1,
                color: '#0000FF',
                fontSize: 12,
                cursor: 'pointer',
                width: material?.material !== 'Powder Coated Steel' ? '80%' : '100%',
                '&:hover': { fontSize: 14 }
              }}
              gutterBottom
              lineHeight={0.8}
              onClick={() => {
                handleChange();
                handleMaterials(value, materials);
              }}
              variant="body1">
              <span style={{ lineHeight: '13px' }}>{material?.material}</span>:{' '}
              <span style={{ lineHeight: '13px' }}>
                {material?.price ? material?.price + '$' : 'Call'}
              </span>
            </Text>
          );
        })
      : null;

  const html = (
    <>
      {loader && <Loader open={loader} />}
      <Grid item xs={4} sx={{ mb: 1, display: imgData?.name == 'Clamps' ? 'none' : '' }}>
        <Card
          sx={{
            m: 1,
            mr: 0,
            minwidth: 230,
            maxWidth: '100%',
            minHeight: imgData.materials?.length > 0 && 243,
            height: imgData.materials?.length > 0 ? '100%' : 'auto',
            backgroundColor: 'white',
            border: highlightColor !== 'white' ? 1 : 0
          }}>
          <CardActionArea onClick={handleChange}>
            <Box sx={{ height: 130, overflow: 'hidden' }}>
              <CardMedia
                component="img"
                image={imgData.imageURL}
                alt={imgData.altText}
                sx={{
                  height: 130,
                  objectFit: 'fill'
                }}
              />
            </Box>
          </CardActionArea>
          <CardContent
            sx={{
              backgroundColor: highlightColor,
              height: '100%',
              p: 1,
              alignVertical: 'center'
            }}>
            {imgData?.detailsURL ? (
              <Grid>
                <Link
                  href={imgData.detailsURL}
                  display="flex"
                  underline="hover"
                  target="_blank"
                  rel="noopener noreferrer">
                  {text}
                </Link>
                {imgData['1stRecommended'] == 1 && '1st Recommendation'}
                {imgData['2ndRecommended'] == 1 && '2nd Recommendation'}
              </Grid>
            ) : (
              text
            )}
            {materials}
          </CardContent>
        </Card>
      </Grid>
    </>
  );
  return imgData.materials?.length > 0 ? materials && html : html;
};

FenceImageBox.propTypes = {
  imgData: PropTypes.object,
  handleChange: PropTypes.func,
  handleMaterials: PropTypes.func
};

export default FenceImageBox;
